// extracted by mini-css-extract-plugin
export default {"SpinnerContainer":"Spinner_SpinnerContainer__FJT56","Spinner":"Spinner_Spinner__zo+Ti","spinner":"Spinner_spinner__83rVF"};